<template>
    <div class="content_box">
        <div class="content faq">
            <div class="tree">
                <el-tree
                    :data="cateInfos"
                    ref="faqRef"
                    node-key="cate_id"
                    :props="defaultProps"
                    :highlight-current="true"
                    :expand-on-click-node="true"
                    :default-expanded-keys="defaultExpandedKeys"
                    :current-node-key="currentNodeKey"
                    @node-click="nodeClick"
                >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>{{ data.cate_name }}</span>
                        <span class="more" v-if="data.cate_id != 0 && roleCheck('101-104-101-102') && roleCheck('101-104-101-103')">
                            <div class="popover_box">
                                <el-popover
                                    popper-class="popover"
                                    placement="right-start"
                                    :offset="-18"
                                    width="60"
                                    trigger="hover">
                                    <div class="act_box">
                                        <p @click="rename(data)" v-if="roleCheck('101-104-101-102')">重命名</p>
                                        <div class="line" v-if="roleCheck('101-104-101-102')"></div>
                                        <p @click="addCate($event,data)" v-if="roleCheck('101-104-101-102')">添加子类</p>
                                        <div class="line" v-if="roleCheck('101-104-101-102')"></div>
                                        <p @click="delCate(data)" v-if="roleCheck('101-104-101-103')">删除分类</p>
                                    </div>
                                    <i class="el-icon-more more-act" slot="reference"></i>
                                </el-popover>
                            </div>
                        </span>
                        <span class="add" v-if="data.cate_id == 0 && roleCheck('101-104-101-102')">
                            <i class="el-icon-plus" @click="addCate($event,data, [])"></i>
                        </span>
                    </span>
                </el-tree>
            </div>
            <div class="faq_content">
                <el-form :inline="true" :model="searchData" class="form-inline search-form">
                    <el-form-item label="问题编号：">
                        <el-input v-model="searchData.problem_id" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="问题标题：">
                        <el-input v-model="searchData.problem_title" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="产品型号：">
                        <el-select v-model="searchData.product_type" placeholder="请选择" clearable>
                            <el-option :label="item" :value="item" v-for="item in productTypes" :key="item + '321423'" ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                    </el-form-item>
                    <br>
                    <el-form-item v-show="currentNodeKey && currentNodeKey != '0'" v-if="roleCheck('101-104-101-102')">
                        <div class="button button2 add" @click="qAdd">
                            <i class="el-icon-plus"></i>
                            <span>添加问题</span>
                        </div>
                    </el-form-item>
                </el-form>
                <el-table
                    :data="faqData" fit highlight-current-row>
                    <el-table-column prop="problem_id" label="问题编号" width="120"></el-table-column>
                    <el-table-column prop="problem_title" label="问题标题" width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="cate" label="分类" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="user_name" label="更新人"></el-table-column>
                    <el-table-column label="更新时间" width="160">
                        <template slot-scope="scope">
                            <span>{{formDate(scope.row.update_Time)}}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="创建时间" width="160">
                        <template slot-scope="scope">
                            <span>{{formDate(scope.row.create_time)}}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="操作" width="150">
                        <template slot-scope="scope">
                            <div class="button text" @click="qView(scope.row)">查看</div>
                            <div class="button text" @click="qUpdate(scope.row)" v-if="roleCheck('101-104-101-102')">编辑</div>
                            <div class="button text del_btn" @click="qDel(scope.row)" v-if="roleCheck('101-104-101-103')">删除</div>
                        </template>
                    </el-table-column>
                </el-table>
                <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
            </div>
            <Tip ref="tip" :msg="tip.msg" @tipBack="tipBack"></Tip>
            <Gh-Dialog ref="dislog" :size="dislog.size" :title="dislog.title" @dialogBack="confirm">
                <template v-slot:content>
                    <el-form label-width="100px" :model="actData" ref="formRule" :rules="formRule">
                        <template v-if="dislog.type == 'rename'">
                            <el-form-item label="分类名称:" prop="cate_name">
                                <el-input v-model="actData.cate_name" maxlength="32" placeholder='请输入分类名称'></el-input>
                            </el-form-item>
                        </template>
                        <template v-else-if="dislog.type == 'addCate'">
                            <el-form-item label="当前分类:">
                                <span>{{currentCate.join(' > ')}}</span>
                            </el-form-item>
                            <el-form-item label="分类名称:" prop="cate_name">
                                <el-input v-model="actData.cate_name" maxlength="32" placeholder='请输入分类名称'></el-input>
                            </el-form-item>
                        </template>
                        <template v-else>
                            <el-form-item label="分类:">
                                <span v-if="dislog.type == 'qView'">{{actData.cate ? actData.cate.replace(/\//g, ' > ') : ''}}</span>
                                <span v-else-if="dislog.type == 'qAdd'">{{currentCate.join(' > ')}}</span>
                                <div class="cascader" v-else>
                                    <el-cascader
                                    v-if="$store.state.type == 'pc'"
                                    v-model="cateIds"
                                    :options="actCateInfos"
                                    :key='cascaderId'
                                    clearable
                                    :props="{ expandTrigger: 'click', children: 'next', label: 'cate_name', value: 'cate_id', checkStrictly: true}"></el-cascader>
                                    <div class="cascader_box" v-else>
                                        <van-field
                                        v-model="cascaderLabel"
                                        is-link
                                        readonly
                                        placeholder="请先选择产品分类"
                                        @click="cascaderShow = true"
                                        />
                                        <van-popup v-model="cascaderShow" round position="bottom">
                                            <van-cascader
                                                v-model="cascaderValue"
                                                title="请先选择产品分类"
                                                :options="actCateInfos"
                                                :fieldNames="{text: 'cate_name', children: 'next', value: 'cate_id'}"
                                                @close="cascaderShow = false"
                                                @finish="cascaderFinish"
                                            />
                                        </van-popup>
                                    </div>
                                </div>
                                
                            </el-form-item>
                            <el-form-item label="问题编号:" v-if="dislog.type != 'qAdd'">
                                <span>{{actData.problem_id}}</span>
                            </el-form-item>
                            <el-form-item label="问题标题:" prop="problem_title">
                                <span v-if="dislog.type == 'qView'">{{actData.problem_title}}</span>
                                <el-input v-else v-model="actData.problem_title" maxlength="50"></el-input>
                            </el-form-item>
                            <el-form-item label="产品型号:">
                                <div v-if="dislog.type == 'qView'">
                                    <span>{{actData.product_types.join(', ')}}</span>
                                </div>
                                <el-checkbox-group v-model="actData.product_types" v-else>
                                    <el-checkbox :label="item" v-for="item in productTypes" :key="item + '4214234'"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item label="解决方案:" prop="answer">
                                <span class="pre" v-if="dislog.type == 'qView'">{{actData.answer}}</span>
                                <el-input type="textarea" v-else v-model="actData.answer" rows="5" maxlength="500" show-word-limit></el-input>
                            </el-form-item>
                            <el-form-item class="block" label="附件：">
                                <fileShow :fileList="actData.file_lists_new" type="log" v-if="dislog.type == 'qView' && actData.file_lists_new.length > 0"></fileShow>
                                <upload :files="[...actData.file_lists_new]" @fileChange="fileChange" v-if="dislog.type != 'qView'"></upload>
                            </el-form-item>
                        </template>
                    </el-form>
                </template>
                <template v-slot:cancel_btn v-if="dislog.type == 'qView'">
                    <div class="button cancel" @click="$refs.dislog.show = false">
                        <span>返回</span>
                    </div>
                </template>
                <template v-slot:cancel_btn v-if="dislog.type == 'qUpdate'">
                    <div class="button cancel" @click="cancelUpdate">
                        <span>取消</span>
                    </div>
                </template>
                <template v-slot:confirm_btn v-if="dislog.type == 'qView'">
                    <span></span>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>
import fileShow from '../../../components/file/file-show'
import upload from '../../../components/file/upload'
export default({
    name: 'faq',
    data() {
        return {
            productTypes: [],
            cateInfos: [{
                cate_id: 0,
                cate_name: '全部问题分类',
                next: []
            }],
            defaultProps: {
                children: 'next',
                label: 'cate_name'
            },
            defaultExpandedKeys: [], //默认展开的节点的 key 的数组
            currentNodeKey: '',  //当前选中的节点
            currentCate: [],
            tip: {},
            dislog: {
                type: '',
                title: '',
                size: '',
                show: false,
            },
            nameList: [],
            searchData: {
                product_id: parseInt(this.$route.params.id),
                cate_ids: '',
                problem_id: '',
                problem_title: '',
                page_size: 10,
                page: 1
            },
            total: 0,
            faqData: [],
            actData: {},
            actCateInfos: [],
            cateIds: [],
            cascaderShow: false,
            cascaderValue: '',
            cascaderLabel: '',
            formRule: {
                cate_name: [
                    {required: true, message: '请输入产品分类名称', trigger: 'blur' }
                ],
                problem_title: [
                    {required: true, message: '请输入问题标题', trigger: 'blur' }
                ],
                answer: [
                    {required: true, message: '请输入解决方案', trigger: 'blur' }
                ]
            },
            cascaderId: 0
        }
    },
    components: {
        fileShow,
        upload
    },
    created() {
        this.init();
    },
    activated() {
        if(this.searchData.product_id != this.$route.params.id){ //从其他分类进入，初始化
            this.init();
        }
    },
    methods: {
        init() {
            this.searchData = {
                product_id: parseInt(this.$route.params.id),
                cate_ids: '',
                problem_id: '',
                problem_title: '',
                page_size: 10,
                page: 1
            };
            if(this.$route.query.key) {
                this.defaultExpandedKeys = this.$route.query.key.split('-').map(item => {
                    return parseInt(item);
                })
            }else{
                this.defaultExpandedKeys = [0]
            }
            this.setCurrentNodeKey();
            this.getCate();
            this.getProduct();
        },
        setRouter(key) {
            this.$router.replace(`?title=${this.$route.query.title}&productTypes=${this.$route.query.productTypes}&key=${key || this.defaultExpandedKeys.join('-')}`);
        },
        getProduct() {
            this.api.getProductCate({product_id: this.$route.params.id}).then(data => {
                this.productTypes = data.data.productCateInfos[0].productTypes;
            })
        },
        getCate(type) {
            this.api.getCate({product_id: this.searchData.product_id}).then( data => {
                this.$set(this.cateInfos, 0, {
                    cate_id: 0,
                    cate_name: '全部问题分类',
                    next: []
                });
                this.$set(this.cateInfos[0], 'next', data.data.cateInfos);
                this.actCateInfos = data.data.cateInfos;
                this.cateInfos = this.filterCate(this.cateInfos);
                this.setCurrentNodeKey();
                this.getProblem();
                this.$nextTick(() => {
                    this.setCate();
                })
                
            })
        },
        filterCate(cate) {
            for(let i=0; i<cate.length; i++) {
                if(cate[i].next && cate[i].next.length > 0) {
                    cate[i].next = this.filterCate(cate[i].next)
                }else{
                    delete cate[i].next;
                }
            }
            return cate;
        },
        nodeClick(data, node) {  //点击节点
            if(this.defaultExpandedKeys[this.defaultExpandedKeys.length - 1] == data.cate_id) {
                return;
            }
            this.currentNodeKey = data.cate_id;
            this.setCate();
            this.getProblem();
            this.setRouter();
        },
        setCate() {
            let treeData = this.$refs.faqRef.getCurrentNode();
            let treeNode = this.$refs.faqRef.getNode(treeData);
            this.currentCate = [];
            this.defaultExpandedKeys = [];
            this.defaultExpandedKeys.push(treeData.cate_id);
            this.currentCate.push(treeData.cate_name);
            this.getParentNode(treeNode);
        },
        getParentNode(node) {  //获取当前点击节点父级信息
            if(node.level == 1) {
                return;
            }
            this.currentCate.unshift(node.parent.data.cate_name);
            this.defaultExpandedKeys.unshift(node.parent.data.cate_id);
            this.getParentNode(node.parent);
        },
        setCurrentNodeKey() {
            this.currentNodeKey = this.defaultExpandedKeys[this.defaultExpandedKeys.length - 1];
            this.$nextTick(() => {
                this.$refs.faqRef.setCurrentKey(this.currentNodeKey);
            })
        },
        rename(data) {
            this.actData = {
                product_id: this.searchData.product_id,
                parents_id: this.defaultExpandedKeys.slice(1, this.defaultExpandedKeys.length - 1),
                cate_id: data.cate_id,
                cate_name: data.cate_name
            };
            this.dislogShow('rename', '重命名');
        },
        addCate(e,data,parents_id) {
            if(this.currentCate.length == 6 && !parents_id) {
                this.$message.warning('最多能添加五级分类!');
                return;
            }
            this.actData = {
                product_id: this.searchData.product_id,
                parents_id: parents_id || this.defaultExpandedKeys.slice(1, this.defaultExpandedKeys.length),
                cate_name: ''
            };
            this.dislogShow('addCate', '添加下级类目');
        },
        tipBack() {
            if(this.tip.type == 'cate') {
                this.delCateConfirm();
            }else{
                this.qDelConfirm();
            }
        },
        delCate(data) {
            this.api.tryDelCate({cate_id: data.cate_id, product_id: this.searchData.product_id}).then(r => {
                if(r.data.is_del) {
                    this.tip = {
                        msg: '确认删除问题分类-' + data.cate_name + '吗，删除后不能再恢复哦！',
                        type: 'cate'
                    };
                    this.$refs.tip.show = true;
                }else{
                    this.$message.warning('该问题分类下有关联的问题，无法删除！');
                }
                
            })
        },
        delCateConfirm() {
            this.api.deleteCate({cate_id: this.defaultExpandedKeys[this.defaultExpandedKeys.length - 1], product_id: this.searchData.product_id}).then(data => {
                this.$refs.tip.show = false;
                this.$message.success('删除成功！');
                this.defaultExpandedKeys.pop();
                this.currentCate.pop();
                this.setCurrentNodeKey();
                this.setRouter();
                this.getProblem();
                this.$refs.faqRef.remove(this.$refs.faqRef.getCurrentNode());
            })
        },
        search() {
            this.searchData.page = 1;
            this.getProblem();
        },
        getProblem() {
            this.searchData.cate_ids = this.defaultExpandedKeys.slice(1, this.defaultExpandedKeys.length);
            this.api.getProblem(this.searchData).then(data => {
                this.faqData = data.data.problemInfos || [];
                this.total = data.data.total;
            })
        },
        qAdd() {
            this.initData({},'qAdd');
            this.dislogShow('qAdd', '添加问题');
        },
        qView(row) {
            this.initData(row);
            this.dislogShow('qView', '查看问题');
        },
        qUpdate(row) {
            this.initData(row);
            this.dislogShow('qUpdate', '编辑问题');
        },
        qDel(row) {
            this.tip = {
                msg: '确认删除问题-' + row.problem_id + '吗，删除后不能再恢复哦！',
                type: 'problem'
            };
            this.$refs.tip.show = true;
            this.initData(row);
        },
        initData(row, type) {
            this.cateIds = [];
            for(let i=1; i<6; i++) {
                if(row['cate_id_' + i] != '0') {
                    this.cateIds.push(parseInt(row['cate_id_' + i]));
                    this.cascaderValue = parseInt(row['cate_id_' + i]);
                }else {
                    break
                }
            }
            this.cascaderLabel = row.cate;
            this.actData = {
                cate: row.cate || '',
                cate_ids: this.defaultExpandedKeys.slice(1, this.defaultExpandedKeys.length),
                product_id: this.searchData.product_id,
                id: row.id || '',
                problem_id: row.problem_id || '',
                problem_title: row.problem_title || '',
                product_types: row.product_types || [],
                answer: row.answer || '',
                file_list: ((type == 'qAdd' || !row.file_lists) ? [] : [...row.file_lists]),
                file_lists_new: ((type == 'qAdd' || !row.file_lists_new) ? [] : [...row.file_lists_new])
            };
            if(type == 'qAdd') {
                this.actData.product_types = this.productTypes;
            }
        },
        qDelConfirm() {
            this.api.deleteProblem({id: this.actData.id, product_id: this.searchData.product_id}).then(data => {
                this.$message.success('删除成功！');
                this.getProblem();
            })
        },
        dislogShow(type, title) {
            this.dislog.type = type;
            this.dislog.title = title;
            this.dislog.size = ('qView,qUpdate,qAdd'.search(type) != -1) ? 'big' : '';
            this.$refs.dislog.show = true;
        },
        cancelUpdate() {
            this.actData.file_list.length = 0;
            this.$refs.dislog.show = false;
        },
        confirm() {
            this.$refs.formRule.validate(v => {
                if(v){
                    let type = this.dislog.type;
                    if(type == 'rename') {  //重命名
                        this.api.updateCate(this.actData).then(data => {
                            this.$message.success('修改成功！');
                            let nodeData = this.$refs.faqRef.getCurrentNode();
                            nodeData.cate_name = this.actData.cate_name;
                            this.currentCate[this.currentCate.length - 1] = this.actData.cate_name;
                        })
                    }else if(type == 'addCate') {  //添加问题类目
                        this.api.createCate(this.actData).then(data => {
                            this.$message.success('添加成功！');
                            this.getCate('add');
                        })
                    }else if(type == 'qAdd'){  //添加问题
                        this.api.createProblem(this.actData).then(data => {
                            this.$message.success('添加成功！');
                            this.getProblem();
                        })
                    }else if(type == 'qUpdate'){  //编辑问题
                        this.actData.cate_ids = this.cateIds;
                        this.api.updateProblem(this.actData).then(data => {
                            this.$message.success('修改成功！');
                            this.getProblem();
                        })
                    }
                    this.$refs.dislog.show = false;
                }
            });
            
        },
        cascaderFinish({selectedOptions}) {
            this.cascaderShow = false;
            this.cascaderLabel = selectedOptions.map((option) => option.cate_name).join('/');
            this.cateIds = selectedOptions.map((option) => option.cate_id);
        },
        fileChange(file, type, i) {
            if(type == 'upload') {
                this.actData.file_list.push(file);
            }else{
                this.actData.file_list.splice(i, 1);
            }
            
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getProblem();
        }
    }
})
</script>
<style lang="less" scoped>
    .el-cascader{
        width: 100%;
    }
    .faq{
        display: flex;
        height: 100%;
        padding: 0;
        overflow: hidden;
        & > div{
            height: 100%;
            box-sizing: border-box;
            overflow-y: auto;
        }
        .tree{
            min-width: 210px;
            width: auto;
            height: 100%;
            padding: 20px 0 20px;
            box-sizing: border-box;
            border-right: 1px solid @colorLine;
        }
        .faq_content{
            flex: 1;
            padding: 20px;
        }
    }
    .el-table{
        overflow-x: hidden;
        margin-top: 0;
    }
    .el-tree{
        &.el-tree--highlight-current {
            /deep/ .el-tree-node.is-current {
                & > .el-tree-node__content {
                    background-color: #e2edf9;
                }
            }
            
        }
        
        /deep/ .el-tree-node__content{
            font-size: 14px;
            color: #333;
            height: 32px;
            padding-right: 26px;
            .el-icon-caret-right{
                color: #666;
                font-size: 18px;
                &.el-tree-node__expand-icon.is-leaf:before{
                    content: '·';
                    font-size: 36px;
                    color: #333;
                    padding-left: 5px;
                }
                
            }
        }
        .add{
            position: absolute;
            top: 0;
            right: 10px; 
            font-size: 18px;
            line-height: 30px;
        }
        .more{
            display: none;
            position: absolute;
            right: 10px;     
            transform: rotate(90deg);  
            .popover_box{
                font-size: 16px;
                bottom: -18px;
                right: -19px;
            } 
        }
        /deep/ .is-current{
            > .el-tree-node__content .more{
                display: inline;
            }
        }
    }
    .el-textarea{
        /deep/ .el-textarea__inner{
            padding-bottom: 36px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/order/knowledge/faq.vue